// src/pages/shipping/Shipping.jsx
import React, { useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import ShippingMethodsTable from "../../components/shipping/Methods/ShippingMethodsTable";
import ShippingZonesTable from "../../components/shipping/Zones/ShippingZonesTable";

const TABS = ["methods", "zones"];

const Shipping = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const [searchParams, setSearchParams] = useSearchParams();
    const initial = TABS.includes(searchParams.get("tab")) ? searchParams.get("tab") : "methods";
    const [tab, setTab] = useState(initial);

    const handleChange = (_e, value) => {
        setTab(value);
        const next = new URLSearchParams(searchParams);
        next.set("tab", value);
        setSearchParams(next, { replace: true });
    };

    const labels = useMemo(
        () => ({
            methods: isArabic ? "طرق الشحن" : "Methods",
            zones:   isArabic ? "مناطق الشحن" : "Zones",
        }),
        [isArabic]
    );

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />

            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}>
                <Tabs value={tab} onChange={handleChange} indicatorColor="primary" textColor="primary">
                    <Tab value="methods" label={labels.methods} />
                    <Tab value="zones"   label={labels.zones} />
                </Tabs>
            </Box>

            <Box sx={{ mt: 2 }}>
                {tab === "methods" && <ShippingMethodsTable />}
                {tab === "zones"   && <ShippingZonesTable />}
            </Box>
        </WrapperSection>
    );
};

export default Shipping;
